import AppModel from '@/models/AppModel'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  postApi: (bvModal, params, callback, errorCallback = null) => {
    return AppModel.post(
      'spec/focus_plan_regist',
      bvModal,
      params,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }
        AppModel.validateStatus(res.data)

        return Promise.resolve(res.data)
      },
      errorCallback, callback
    )
  }
}



// WEBPACK FOOTER //
// ./src/models/FocusPlanRegistModel.js